import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";
import ThumpnailsDesigner from "../../../components/ThumbnailsDesigner";
import Slider from "react-slick";
import Spinner from "../../../components/Spinner/Spinner";
import { Message } from "semantic-ui-react";
import styles from "./SliderDesigners.module.scss";
import { slickSettings } from "../../../utils/reusableFunctions";
import { getProfiles } from "../../../actions/profileActions";

type Props = {};

const SliderDesigners: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const profileList = useSelector((state: any) => state.profileList);
  const { loading, error, profiles } = profileList;
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const selectedCategory = searchParams.get("categories");

  const categoryName = selectedCategory
    ? intl.formatMessage({
        id: `categories.categories.${selectedCategory}`,
        defaultMessage: selectedCategory,
      })
    : intl.formatMessage({
        id: "category.page.sliderCategoryAll",
        defaultMessage: "all categories",
      });

  useEffect(() => {
    dispatch(getProfiles());
  }, [dispatch]);

  return (
    <article className={styles.sliderDesigners}>
      <h4>
        <FormattedMessage
          id={"nav.thumpnailsDesignerTitle"}
          defaultMessage={"Top rated designers in the category of {category}"}
          values={{ category: categoryName }}
        />
      </h4>
      {loading ? (
        <Spinner />
      ) : error ? (
        <Message negative>
          <p>{JSON.stringify(error)}</p>
        </Message>
      ) : (
        <Slider {...slickSettings}>
          {profiles &&
            profiles.map((profile: any, i: number) => (
              <ThumpnailsDesigner
                key={`${profile.handle}-${i}`}
                thumb={{
                  url:
                    profile.user && profile.user.avatar
                      ? profile.user.avatar
                      : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png",
                  designer: profile.handle,
                  rate: 5,
                  number: profile.patterns ? profile.patterns.length : 0,
                }}
              />
            ))}
        </Slider>
      )}
    </article>
  );
};

export default SliderDesigners;
